import _ from "lodash"

export const filterCoachesByGame = game => coaches => {
  return coaches.filter(coach => {
    const coachGames = Object.keys(coach.games || {})
    return coachGames.includes(game)
  })
}

export const filterCoachesByRegions = (game, regions) => coaches => {
  return !_.isEmpty(regions)
    ? coaches.filter(coach => {
      return regions.some(region => {
        const coachRegions = _.get(coach, ["games", game, "regions"], [])
        return coachRegions.includes(region)
      })
    })
    : coaches
}

export const filterCoachesByRanks = (game, ranks) => coaches => {
  return !_.isEmpty(ranks)
    ? coaches.filter(coach => {
      const coachRank = _.get(coach, ["games", game, "rank"])
      return ranks.includes(coachRank)
    })
    : coaches
}

export const filterCoachesByLanguages = languages => coaches => {
  return !_.isEmpty(languages)
    ? coaches.filter(coach => {
      const coachLanguages = (coach.primary_languages || []).map(language => language.slice(0, 3).toLowerCase())
      return coachLanguages.some(language => languages.includes(language))
    })
    : coaches
}

export const filterCoachesByPlatforms = platforms => coaches => {
  return !_.isEmpty(platforms)
    ? coaches.filter(coach => {
      const coachPlatforms = (coach.platforms || []).map(platform => platform.toLowerCase())
      return coachPlatforms.some(platform => platforms.includes(platform))
    })
    : coaches
}

export const filterCoachesBySpecialties = (game, specialties) => coaches => {
  return !_.isEmpty(specialties)
    ? coaches.filter(coach => {
      return specialties.some(specialty => {
        const coachGameSpecialties = _.get(coach, ["games", game, "specialties"], [])
        const coachGameSpecializationItems = _
          .chain(coach)
          .get(["games", game, "specializationGroupItems"], {})
          .values()
          .flatten()
          .value()
        return coachGameSpecialties.includes(specialty) || coachGameSpecializationItems.includes(specialty)
      })
    })
    : coaches
}

export const filterCoachesByPrices = (game, prices) => coaches => {
  return !_.isEmpty(prices)
    ? coaches.filter(coach => {
      const coachPrices = Object.values(_.get(coach, ["games", game, "price"], {}))
      const coachMin = Math.min(...coachPrices)
      const coachMax = Math.max(...coachPrices)
      for (let i = 0; i < prices.length; i++) {
        if (coachMin >= prices[i].min && coachMax <= prices[i].max) {
          return true
        }
      }
      return false
    })
    : coaches
}

export const filterCoachesBySearchQuery = (game, searchQueryValue) => coaches => {
  const searchVal = searchQueryValue.toLowerCase()
  return !_.isEmpty(searchVal)
    ? coaches.filter(coach => {
      let valid = false
      let coachName = coach.name.toLowerCase()
      let coachRank = _.get(coach, ["games", game, "rank"], "").toLowerCase()
      let coachRoles = _.get(coach, ["games", game, "specialties"], [])
      if (coachName.includes(searchVal)) {
        valid = true
      } else if (coachRank.includes(searchVal)) {
        valid = true
      } else {
        for (let i = 0; i < coachRoles.length; i++) {
          if (coachRoles[i].toLowerCase().includes(searchVal)) {
            valid = true
          }
        }
      }
      return valid
    })
    : coaches
}



// WEBPACK FOOTER //
// ./src/store/coaching/widget/coach-filters/coach-filters.utils.js